import React from 'react';
import styled from '@emotion/styled';
import CardConfiguracaoUnidade from '../../../../components/CardConfiguracaoUnidade';

const Gerais = ({ venda, configuracaoUnidade, onChange, disabled }) => {
  return (
    <Container>
      <CardConfiguracaoUnidade
        title="Documentos"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'utilizaFotoUnidadeGuiaSadt', label: 'Utilizar foto da unidade como logo da guia SADT?', type: 'switch' },
        ]}
      />

      <CardConfiguracaoUnidade
        title="Atendimento"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'permiteAdministradorVerProntuarios', label: 'Permite administradores ver todos os prontuários?', type: 'switch' },
          { value: 'permiteCompartilharProntuarioEntreUnidades', label: 'Permite visualizar os prontuarios de outras unidades da mesma rede?', type: 'switch' },
          { value: 'utilizaAssinaturaPresenca', label: 'Utiliza a solicitação de assinatura de presença?', type: 'switch' },
        ]}
      />

      <CardConfiguracaoUnidade
        title="Repasse"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'utilizaConfiguracaoRepasse', label: 'Utilizar o repasse para os médicos?', type: 'switch' },
        ]}
      />

      <CardConfiguracaoUnidade
        title="Configuração de atendimento"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'utilizaCidObrigatorio', label: 'Informar o CID no atendimento', type: 'switch' },
          { value: 'utilizaBaixaReceita', label: 'Utiliza baixa de receita controlada?', type: 'switch' },
          { value: 'obrigaEvolucaoProntuario', label: 'Obrigar a evolução do prontuario do paciente?', type: 'switch' },
          { value: 'permiteAtendimentoOrcamentoAprovado', label: 'Permite realizar atendimentos para procedimentos vinculados a orçamentos odontológicos com status Aprovado?', type: 'switch' },
        ]}
      />

      <CardConfiguracaoUnidade
        title="Assinatura digital obrigatória"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'assinaturaDigitalObrigatoria', label: 'Utilizar em Receitas, Guia SADT e Documentos', type: 'switch' },
        ]}
      />

      <CardConfiguracaoUnidade
        title="Orçamento"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'utilizaFiltroDeProcedimentosPorConvenio', label: 'Apresenta somente procedimentos do convenio para orçamento', type: 'switch' },
          { value: 'limiteDescontoOrcamento', name: 'limiteDescontoOrcamento', label: 'Limite do desconto no orçamento (%)', type: 'input' },
          { value: 'permiteDuplicidadeOrcamento', label: 'Permite a criação de orçamentos duplicados', type: 'switch' },
          { value: 'utilizaImpressaoDetalhadaOrcamentoOdontologico', label: 'Utiliza impressão detalhada', type: 'switch' },
        ]}
      />

      <CardConfiguracaoUnidade
        title="Mensagem Personalizada"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'utilizaMensagemPersonalizada', label: 'Utiliza mensagem personalizada', type: 'switch' },
        ]}
      />

      <CardConfiguracaoUnidade
        title="Relatório"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'mostrarApenasProfissionaisAtivo', label: 'Mostrar apenas os profissionais ativos no relatório', type: 'switch' },
        ]}
      />

      <CardConfiguracaoUnidade
        title="Procedimentos"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'utilizaValorCustoProcedimento', label: 'Controlar valor de custo de procedimentos', type: 'switch' },
        ]}
      />

      <CardConfiguracaoUnidade
        title="API Dasa"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'utilizaDasa', label: 'Utilizar API Dasa', type: 'switch' },
        ]}
      />

      <CardConfiguracaoUnidade
        title="API Pacsweb"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'utilizaPacsweb', label: 'Utilizar API Pacsweb', type: 'switch' },
        ]}
      />

      <CardConfiguracaoUnidade
        title="Procedimento odontológico"
        configuracaoUnidade={configuracaoUnidade}
        onChange={onChange}
        disabled={disabled}
        fields={[
          { value: 'permiteFinalizarProcedimentoOdontologicoSemFaturamento', label: 'Permitir finalização de procedimento odontológico sem faturamento', type: 'switch' },
        ]}
      />
    </Container>
  );
};

export default Gerais;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
